export default __webpack_public_path__ + "static/media/atuadores-hidraulicos-534x444.bee53a16.png";